module.exports = __webpack_public_path__ + "img/diente28.84bce487.png";